import React, { useRef } from 'react';

import EditableTag from '../shared/EditableTag';
import SelectAppender from './SelectAppender';
import { deleteItem, focusRef } from '../shared/EventHelpers';

const EditSelectMany = ({ iconName, value: values, setValue: setValues, options, isInvalid, onSave, autoFocus, handleCancel }) => {
    const inputRef = useRef();

    const handleDelete = (value) => {
        deleteItem(values, setValues, value);
        focusRef(inputRef);
    };

    return (
        <div className='crm-editable-field-wrapper'>
            <div className={`input-wrapper ${isInvalid ? 'invalid' : ''}`} onClick={() => focusRef(inputRef)}>
                {values && values.map((v) => <EditableTag key={v.id} label={v.name} handleDelete={() => handleDelete(v)} />)}
                <SelectAppender {...{ iconName, values, setValues, options, onSave, inputRef, autoFocus, handleCancel }} />
            </div>
        </div>
    );
};

export default EditSelectMany;
